<template>
  <div class="in-modal">
    <modal
      name="xls-export"
      transition="nice-modal-fade"
      :min-width="200"
      :min-height="200"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="true"
      :reset="true"
      width="80%"
      height="auto"
    >
      <div class="header">
        <h1>{{ $t("message.export_to", {format: 'XLS'}) }}</h1>
      </div>

      <div class="content row">
        <div class="col-lg-12 col-md-12 col-sm-12 columns">
          <label>{{ $t("message.columns") }}</label>
          <label>
            <button class="btn btn-link" @click="enable_edit_mode()" v-if="!edit_mode">
              <i class="fa fa-pencil-square" aria-hidden="true"></i>
              {{ $t('message.columns_text') }}
            </button>
          </label>
          <div class="form-check">
            <label class="form-check-label row" v-for="item in columns" :key="item.slug">
              <input
                class="form-check-input"
                type="checkbox"
                :value="item.slug"
                :checked="item.checked"
                v-model="item.checked"
              >
              <div v-if="edit_mode">
                <input type="text" class="form-control form-control-sm" v-model="item.text">
              </div>
              <div v-else>{{item.text}}</div>
            </label>
          </div>
        </div>

        <div class="col-lg-12 buttons">
          <button
            :href="url"
            target="_blank"
            class="btn btn-primary"
            @click="download()"
            :disabled="disabled"
          >{{ $t("message.download") }}</button>
          <button class="btn btn-default" @click="hide('xls-export')">{{ $t("message.cancel") }}</button>
        </div>
      </div>
    </modal>
    <button class="btn btn-primary btn-block" @click="show('xls-export')">
      <i class="fa fa-file-excel"></i>&nbsp;&nbsp;xls
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { helpers } from "../mixins/helpers";

export default {
  mixins: [helpers],
  name: "XlsExport",
  data() {
    return {
      format: "xls",
      disabled: false,
      columns: [],
      edit_mode: false
    };
  },
  methods: {
    show(name) {
      this.$modal.show(name);
    },
    hide(name) {
      this.$modal.hide(name);
    },
    exportToXls() {
      console.log("XlsExport component: export xls");
    },
    download() {
      this.hide("xls-export");
      location.href = this.url;
    },
    enable_edit_mode() {
      this.edit_mode = true;
    }
  },
  computed: {
    ...mapGetters('pricelist', ['listType']),
    url() {
      const columns = this.columns.filter(item => item.checked).map(item => item.slug);
      const names = this.columns.filter(item => item.checked).map(item => this.podmien(item.text));
      // const names = this.columns
      //   .filter(item => item.checked)
      //   .map(item => item.text);

      if (columns.length > 0) {
        this.disabled = false;
        return (
          this.axios.defaults.baseURL +
          "pricelist" +
          this.storage_url_ids +
          '?company=' + this.listType +
          "&format=" + this.format +
          '&discount=' + this.discount +
          "&columns=" + columns +
          "&names=" + names +
          "&lang=" + this.locale
        );
      }
      this.disabled = true;
      return;
    },
    storage_url_ids() {
      const storage = this.$store.getters["pricelist/storage"];
      const is_storage = this.$store.getters["pricelist/is_storage"];
      const ids = storage.map(item => item.id);
      if (is_storage && storage.length) {
        return "/" + ids + "/";
      }
      return "";
    },
    discount() {
      return this.$store.getters["pricelist/discount"];
    },
    locale() {
      return this.$store.getters["pricelist/locale"];
    }
  },
  created() {
    let currency = this.$i18n.locale === "pl" ? "PLN" : "EUR";
    if (this.$i18n.locale === 'pl') {
      this.columns = [
        {slug: "image", checked: false, text: this.$t("message.product_photo")},
        {slug: "code", checked: true, text: this.$t("message.product_code")},
        {slug: "name", checked: true, text: this.$t("message.product_name")},
        {slug: "price", checked: true, text: this.$t("message.price") + " " + currency},
        {slug: "price_sale", checked: true, text: this.$t("message.price_sale") + " " + currency},
        {slug: "price_dealer", checked: false, text: this.$t("message.price_dealer") + " " + currency},
        {slug: "description", checked: false, text: this.$t("message.description")},
        {slug: "ean", checked: false, text: this.$t("message.ean_code")},
        {slug: "pcn", checked: false, text: this.$t("message.pcn_code")},
        {slug: "producer", checked: false, text: this.$t("message.producer")},
        {slug: "weight", checked: false, text: this.$t("message.weight")},
        {slug: "dimensions", checked: false, text: this.$t("message.dimensions")},
        {slug: 'size', checked: false, text: this.$t('message.size')},
        {slug: 'warranty', checked: false, text: this.$t('message.warranty')},
        {slug: 'package', checked: false, text: this.$t('message.package')},

        {slug: "categories", checked: false, text: this.$t("message.categories")},
        {slug: "linkImg", checked: false, text: this.$t("message.linkImg")},
        {slug: "linkKK", checked: false, text: this.$t("message.linkKK")}
      ];

      if (process.env.VUE_APP_Log_In == false) {
        this.columns.push({slug: "coo", checked: false, text: this.$t("message.coo")})
      }

    } else {
      this.columns = [
        {slug: "image", checked: false, text: this.$t("message.product_photo") },
        {slug: "code", checked: true, text: this.$t("message.product_code") },
        {slug: "name", checked: true, text: this.$t("message.product_name") },
        {slug: "price", checked: true, text: this.$t("message.price") + " " + currency},
        {slug: "price_sale", checked: true, text: this.$t("message.price_sale") + " " + currency},
        {slug: "price_dealer", checked: false, text: this.$t("message.price_dealer") + " " + currency},
        {slug: "description", checked: false, text: this.$t("message.description")},
        {slug: "ean", checked: false, text: this.$t("message.ean_code")},
        {slug: "pcn", checked: false, text: this.$t("message.pcn_code")},
        {slug: "producer", checked: false, text: this.$t("message.producer")},
        {slug: "weight", checked: false, text: this.$t("message.weight")},
        {slug: "dimensions", checked: false, text: this.$t("message.dimensions")},
        {slug: 'size', checked: false, text: this.$t('message.size')},
        {slug: 'warranty', checked: false, text: this.$t('message.warranty')},
        {slug: 'package', checked: false, text: this.$t('message.package')},

        {slug: "categories", checked: false, text: this.$t("message.categories")},
        {slug: "linkImg", checked: false, text: this.$t("message.linkImg")},
        {slug: "linkKK", checked: false, text: this.$t("message.linkKK")}
      ];

      if (process.env.VUE_APP_Log_In == false) {
        this.columns.push({slug: "coo", checked: false, text: this.$t("message.coo")})
      }

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color: #388e57;

.in-modal {
  h1 {
    margin-bottom: 0;
    font-size: 1.4em;
  }
  .content {
    padding: 15px 30px;
    .separator {
      select {
        font-size: 0.8em;
        option {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          padding: 15px 0;
        }
      }
    }
  }
  .header {
    background: @color;
    padding: 15px 30px;
    color: #fff;
  }
  .form-check-label {
    font-size: 0.8em;
  }
  .buttons {
    margin-top: 30px;
    text-align: right;
  }
}
.btn-link {
  white-space: normal;
}
.btn-primary,
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  background: @color;
  color: #fff;
  border-color: @color;
}
</style>



// WEBPACK FOOTER //
// src/components/Export/XlsExport.vue